//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getUnionInfo} from '../../api/index'
    export default {
        name: "union_footer",
        data() {
            return {
                tabBarImg: [
                    {
                        path: 'union',
                        vice: 'union',
                        normal: require('../assets/img/union/f1.png'),
                        title: '联盟首页'
                    },
                    {
                        path: 'union_live_broadcast',
                        vice: 'union_live_broadcast',
                        normal: require('../assets/img/union/f2.png'),
                        title: '直播大厅'
                    },
                    {
                        path: 'ordinary-user',
                        vice: 'manager_index',
                        normal: require('../assets/img/union/f3.png'),
                        title: '个人中心'
                    }
                ],
                footer_color: '',
            }
        },
        methods: {
            changeIcon(index, item){
                if(index == 0){
                    return this.union_index_icon
                }
                if(index == 1){
                    return this.union_live_icon
                }
                if(index == 2){
                    return this.union_my_icon
                }
            },
            switchToTab(path) {
                this.$router.push({name: path})
            }
        },
        mounted() {
          getUnionInfo().then(res => {
              let _this = this
              if(res.code == 0){
                  _this.footer_color = '#'+res.data.footer_color
                  _this.union_index_icon = res.data.union_index_icon
                  _this.union_live_icon = res.data.union_live_icon
                  _this.union_my_icon = res.data.union_my_icon
              }
          })
        }
    }



// WEBPACK FOOTER //
// ./src/components/union_footer.vue